/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ProductSortimentEntryUpdateRequest } from '../../models/product-sortiment-entry-update-request';

export interface UpdateProductSortimentEntries$Params {

/**
 * UUID of the product sortiment entry (productSortimentId)
 */
  prodSortId: string;
      body: ProductSortimentEntryUpdateRequest
}

export function updateProductSortimentEntries(http: HttpClient, rootUrl: string, params: UpdateProductSortimentEntries$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateProductSortimentEntries.PATH, 'put');
  if (params) {
    rb.path('prodSortId', params.prodSortId, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateProductSortimentEntries.PATH = '/sortiments/products/{prodSortId}/entries';
